
import request from '@/request'
const part_url = '/recruit/workExperience/';

function getById(data) {
  let url = part_url + "getById";
  return request.get(url, data)
}

function add(data) {
  let url = part_url + "add";
  return request.post(url,{}, data)
}

function edit(data) {
  let url = part_url + "edit";
  return request.post(url,{}, data)
}

function deleteById(data){
  let url = part_url + "deleteById";
  return request.get(url,data)
}


export default {
    getById,
    add,
    edit,
    deleteById
  }


// WEBPACK FOOTER //
// ./src/api/workExperience.js